var path = 'mobile/admin/chatter/api.tpl.html';
var html = "<div class=\"sbsf-api\">\n\n  <div ng-controller=\"ApiHistoryCtrl\" ng-include=\" 'admin/api/usage/usage.tpl.html' \"></div>\n\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;